import { __assign } from "tslib";
var EMAIL_PREFIX = 'from:';
var NUMBER_PREFIX = 'number:';
var isValidEmailAddress = function (text) {
    var emailRe = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRe.test(String(text).toLowerCase());
};
var isValidTicketNumber = function (text) {
    return /^[\d+]{7,10}$/.test(text);
};
var maybeAppendPrefix = function (text) {
    if (isValidEmailAddress(text)) {
        return "".concat(EMAIL_PREFIX).concat(text);
    }
    else if (isValidTicketNumber(text)) {
        return "".concat(NUMBER_PREFIX).concat(text);
    }
    else {
        return text;
    }
};
var processText = function (dto) {
    var text = dto.text;
    if (text && text.indexOf(EMAIL_PREFIX) > -1) {
        var userEmail = text.split(EMAIL_PREFIX)[1];
        return __assign(__assign({}, dto), { userEmail: userEmail, text: '' });
    }
    else if (text && text.indexOf(NUMBER_PREFIX) > -1) {
        var ticketNumber = text.split(NUMBER_PREFIX)[1];
        return __assign(__assign({}, dto), { ticketNumber: ticketNumber, text: '' });
    }
    else {
        return dto;
    }
};
export var processTicketSearchDto = function (dto) {
    var newDto = __assign({}, dto);
    newDto.text = newDto.text && maybeAppendPrefix(newDto.text);
    return processText(newDto);
};
//# sourceMappingURL=process-ticket-search-dto.js.map